import React from "react";
import { ArrowLeft } from "lucide-react";

const VehicleRecommendationPanel = ({
  mapRef,
  onBack,
vehicles,
  orderedVehicles,
  activeVehicle,
  handleVehicleSelect,
  getVehicleMeta,
  faresLoading,
}) => {
  return (
    <div className="order-1 flex flex-col lg:order-2">
      <div className="order-1 flex h-[360px] bg-slate-100 p-3 sm:h-[350px] md:h-[450px] lg:order-2 lg:h-full lg:p-5">
        <div className="relative h-full w-full overflow-hidden rounded-3xl border border-white/70 bg-white shadow-inner">
          <div ref={mapRef} className="h-full w-full" />
        </div>
      </div>
      {/* Mobile Back Button */}
{/* <div className="order-2 px-3 pt-2 pb-4 lg:hidden">
  <button
    type="button"
    onClick={onBack}
    className="inline-flex items-center gap-2 rounded-2xl border border-slate-200 bg-white px-4 py-2 text-sm font-bold text-slate-700 transition hover:bg-slate-50"
  >
    <ArrowLeft size={17} />
    Back
  </button>
</div> */}

        <div className="order-3 bg-[#fbf6e7] px-3 py-5 sm:px-6 sm:py-8 lg:order-2 lg:px-7 lg:py-5">
            <div className="order-2 px-3 pt-2 pb-4 lg:hidden">
  <button
    type="button"
    onClick={onBack}
    className="inline-flex items-center gap-2 rounded-2xl border border-slate-200 bg-white px-4 py-2 text-sm font-bold text-slate-700 transition hover:bg-slate-50"
  >
    <ArrowLeft size={17} />
    Back
  </button>
</div>
            <div className="mx-auto max-w-[420px]">
         
              <h4 className="mb-3 text-base font-bold text-gray-500">
                Recommended Vehicles
              </h4>

              <div className="space-y-4">
                {vehicles.map((vehicle) => (
                  <div
                    key={vehicle.name}
                    onClick={() => handleVehicleSelect(vehicle.name)}
                    className={`cursor-pointer overflow-hidden rounded-lg border bg-white transition ${
                      activeVehicle === vehicle.name
                        ? "border-orange-400 bg-orange-100"
                        : "border-gray-200 hover:border-orange-200"
                    }`}
                  >
                    <div
                      className={`flex flex-col gap-3 px-4 py-3 sm:flex-row sm:items-center sm:justify-between ${
                        activeVehicle === vehicle.name
                          ? "bg-orange-100"
                          : "bg-white"
                      }`}
                    >
                      <div className="flex w-full items-center gap-3">
                        <div className="flex h-16 w-16 items-center justify-center">
                          <img
                            src={vehicle.img}
                            alt={vehicle.name}
                            className="h-12 w-12 object-contain"
                          />
                        </div>

                        <div>
  <h3 className="font-bold text-gray-800">
    {vehicle.name}
  </h3>

  {activeVehicle === vehicle.name ? (
    <div className="text-sm leading-5 text-gray-600">
      <p>
        <b>Weight:</b> {getVehicleMeta(vehicle.vehicleId).weight}
      </p>

      <p>
        <b>Dimension:</b> {getVehicleMeta(vehicle.vehicleId).dimension}
      </p>

      {faresLoading ? (
        <div className="mt-2 h-6 w-20 rounded-md bg-gray-200 animate-pulse" />
      ) : (
        <p className="mt-2 text-lg font-bold text-gray-900">
          ₹{vehicle.price}
        </p>
      )}
    </div>
  ) : (
    <div className="text-sm text-gray-500">
      <p>W: {getVehicleMeta(vehicle.vehicleId).weight}</p>
      <p>D: {getVehicleMeta(vehicle.vehicleId).dimension}</p>

      {faresLoading ? (
        <div className="mt-2 h-6 w-20 rounded-md bg-gray-200 animate-pulse" />
      ) : (
        <p className="mt-2 text-lg font-bold text-gray-900">
          ₹{vehicle.price}
        </p>
      )}
    </div>
  )}
</div>
                      </div>

            
                    </div>

                    {activeVehicle === vehicle.name && (
                      <div className="border-t border-orange-300 bg-white px-4 py-3 text-sm text-gray-500">
                        {vehicle.best}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
    </div>
  );
};

export default VehicleRecommendationPanel;